export default function signeture({ next, router, store }) {
    // if (store.state.auth.user && store.state.auth.user.signature == null) {
    //     // console.log(store.state.auth.user.signature)
    //     return next({
    //         path: '/profile',
    //     })
    // }
    // return next()
}